import React from "react";
import { Col, Row, Typography, Card, Space } from "antd";
import { UserOutlined, DollarOutlined, FileTextOutlined, SettingOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const Guides = () => {
  return (
    <Row type="flex">
      <Col span={20} offset={1}>
        <Title level={2}>User Guides</Title>
        <Paragraph style={{ fontSize: '16px', marginBottom: '32px' }}>
          Select a guide below to access detailed step-by-step instructions for each part 
          of the vendor pre-qualification process. Each guide includes common questions, 
          troubleshooting tips, and best practices.
        </Paragraph>

        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Card 
            hoverable
            style={{ cursor: 'pointer' }}
            onClick={() => {
              const menuItem = document.querySelector('[data-menu-item-key="VendorProfile"]');
              if (menuItem) menuItem.click();
            }}
          >
            <Space size="large">
              <UserOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
              <div>
                <Title level={4} style={{ margin: 0 }}>i4 Vendor Profile</Title>
                <Paragraph style={{ marginBottom: 0 }}>
                  Learn how to complete your vendor profile, including all required sections 
                  such as basic details, financial information, safety records, and documentation 
                  uploads. This guide covers common questions and troubleshooting.
                </Paragraph>
              </div>
            </Space>
          </Card>

          <Card 
            hoverable
            style={{ cursor: 'pointer' }}
            onClick={() => {
              const menuItem = document.querySelector('[data-menu-item-key="payment"]');
              if (menuItem) menuItem.click();
            }}
          >
            <Space size="large">
              <DollarOutlined style={{ fontSize: '32px', color: '#52c41a' }} />
              <div>
                <Title level={4} style={{ margin: 0 }}>Payment</Title>
                <Paragraph style={{ marginBottom: 0 }}>
                  Understand the payment process, pricing structure, payment methods, and how 
                  to resolve payment issues. Includes information about initial PQQ fees and 
                  annual recertification costs.
                </Paragraph>
              </div>
            </Space>
          </Card>

          <Card 
            hoverable
            style={{ cursor: 'pointer' }}
            onClick={() => {
              const menuItem = document.querySelector('[data-menu-item-key="ppqsubmission"]');
              if (menuItem) menuItem.click();
            }}
          >
            <Space size="large">
              <FileTextOutlined style={{ fontSize: '32px', color: '#fa8c16' }} />
              <div>
                <Title level={4} style={{ margin: 0 }}>PQQ Submission</Title>
                <Paragraph style={{ marginBottom: 0 }}>
                  Step-by-step instructions for attaching your profile to a PQQ, certifying 
                  your submission, and understanding submission status. Learn about approver 
                  permissions and certification requirements.
                </Paragraph>
              </div>
            </Space>
          </Card>

          <Card 
            hoverable
            style={{ cursor: 'pointer' }}
            onClick={() => {
              const menuItem = document.querySelector('[data-menu-item-key="account"]');
              if (menuItem) menuItem.click();
            }}
          >
            <Space size="large">
              <SettingOutlined style={{ fontSize: '32px', color: '#722ed1' }} />
              <div>
                <Title level={4} style={{ margin: 0 }}>Account Management</Title>
                <Paragraph style={{ marginBottom: 0 }}>
                  Manage your account settings, user permissions, password reset, and understand 
                  the difference between different user roles (Admin, Approver, User). Learn how 
                  to add or remove team members.
                </Paragraph>
              </div>
            </Space>
          </Card>
        </Space>

        <div style={{ marginTop: '32px', padding: '16px', backgroundColor: '#f0f2f5', borderRadius: '4px' }}>
          <Text strong>Tip:</Text> You can also access these guides directly from the sidebar menu 
          under the "Guides" section. Each guide contains detailed FAQs and troubleshooting information 
          specific to that topic.
        </div>
      </Col>
    </Row>
  );
};

export default Guides;
